var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("user-reviews") }, [
    _c("div", { class: _vm.getClassName("user-reviews__header") }, [
      _c("div", { class: _vm.getClassName("user-reviews__summary") }, [
        _vm._v("レビュー")
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { class: _vm.getClassName("stars") },
          _vm._l(_vm.starMax, function(n) {
            return _c("IconStar", {
              key: "average" + n,
              class: _vm
                .getClassName("stars__items")
                .concat(["stars__items--average"]),
              attrs: { active: Math.floor(_vm.getAverage) >= n }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("user-reviews__average") }, [
          _vm._v(_vm._s(_vm.starMax) + "つ星のうち" + _vm._s(_vm.getAverage))
        ])
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("user-reviews__show") }, [
        _c("span", { class: _vm.getClassName("user-reviews__count") }, [
          _vm._v(_vm._s(_vm.getCount) + "件")
        ]),
        _vm._v("のカスタマーレビュー\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.getCount > 0 || _vm.user !== null,
            expression: "getCount > 0 || user !== null"
          }
        ],
        class: _vm.getClassName("user-reviews__container")
      },
      [
        _c(
          "transition",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.getCount > 0,
                expression: "getCount > 0"
              }
            ],
            attrs: { name: "user-reviews__reviews-" }
          },
          [
            _vm.visibleReviews
              ? _c(
                  "div",
                  { staticClass: "user-reviews__reviews" },
                  _vm._l(_vm.reviews, function(review) {
                    return _c(
                      "div",
                      { key: review.id, class: _vm.getClassName("review") },
                      [
                        _c(
                          "div",
                          { class: _vm.getClassName("review__header") },
                          [
                            _c(
                              "div",
                              {
                                class: _vm
                                  .getClassName("review__stars")
                                  .concat(_vm.getClassName("stars"))
                              },
                              _vm._l(_vm.starMax, function(n) {
                                return _c("IconStar", {
                                  key: "review" + review.id + "-" + n,
                                  class: _vm
                                    .getClassName("stars__items")
                                    .concat(["stars__items"]),
                                  attrs: { active: review.star >= n }
                                })
                              }),
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.getClassName("review__title") },
                          [_vm._v(_vm._s(review.title))]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          class: _vm.getClassName("review__comment"),
                          domProps: { textContent: _vm._s(review.comment) }
                        }),
                        _vm._v(" "),
                        review.answer
                          ? _c("div", {
                              class: _vm.getClassName("review__answer"),
                              domProps: { textContent: _vm._s(review.answer) }
                            })
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.visibleReviews
              ? _c(
                  "div",
                  { staticClass: "user-reviews__reviews reviews-close" },
                  [
                    _vm._l(_vm.reviews, function(review) {
                      return _c(
                        "div",
                        { key: review.id, class: _vm.getClassName("review") },
                        [
                          _c(
                            "div",
                            { class: _vm.getClassName("review__header") },
                            [
                              _c(
                                "div",
                                {
                                  class: _vm
                                    .getClassName("review__stars")
                                    .concat(_vm.getClassName("stars"))
                                },
                                _vm._l(_vm.starMax, function(n) {
                                  return _c("IconStar", {
                                    key: "review" + review.id + "-" + n,
                                    class: _vm
                                      .getClassName("stars__items")
                                      .concat(["stars__items"]),
                                    attrs: { active: review.star >= n }
                                  })
                                }),
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { class: _vm.getClassName("review__title") },
                            [_vm._v(_vm._s(review.title))]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            class: _vm.getClassName("review__comment"),
                            domProps: { textContent: _vm._s(review.comment) }
                          }),
                          _vm._v(" "),
                          review.answer
                            ? _c("div", {
                                class: _vm.getClassName("review__answer"),
                                domProps: { textContent: _vm._s(review.answer) }
                              })
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-reviews__more" }, [
                      _c("div", { staticClass: "user-reviews__wrap" }),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.showReviews(_vm.visibleReviews)
                              }
                            }
                          },
                          [_vm._v("もっと見る")]
                        )
                      ])
                    ])
                  ],
                  2
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.visibleReviewForm
          ? _c(
              "v-form",
              {
                ref: "edit",
                class: _vm.getClassName("form"),
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.postReview($event)
                  }
                }
              },
              [
                _c("div", { class: _vm.getClassName("form__value") }, [
                  _c("div", { class: _vm.getClassName("form__term") }, [
                    _vm._v("評価")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.getClassName("stars") },
                    _vm._l(_vm.starMax, function(n) {
                      return _c(
                        "a",
                        {
                          key: "form" + n,
                          class: _vm
                            .getClassName("stars__items")
                            .concat(["stars__items--form"]),
                          on: {
                            click: function($event) {
                              _vm.form.star = n
                            },
                            mouseenter: function($event) {
                              _vm.form.star = n
                            }
                          }
                        },
                        [
                          _c("IconStar", {
                            class: _vm
                              .getClassName("stars__items")
                              .concat(["stars__items--form"]),
                            attrs: { active: _vm.form.star >= n }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("v-text-field", {
                  class: _vm.getClassName("form__field"),
                  attrs: { label: "タイトル" },
                  model: {
                    value: _vm.form.title,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title"
                  }
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  class: _vm.getClassName("form__textarea"),
                  attrs: { label: "コメント", "auto-grow": "", rows: "1" },
                  model: {
                    value: _vm.form.comment,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "comment", $$v)
                    },
                    expression: "form.comment"
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: _vm.getClassName("form__button"),
                    attrs: { type: "submit", disabled: _vm.isFetching }
                  },
                  [_vm._v("投稿")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.user !== null && !_vm.visibleReviewForm
          ? _c("div", { class: _vm.getClassName("user-reviews__footer") }, [
              _c(
                "button",
                {
                  class: _vm.getClassName("user-reviews__button"),
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.visibleReviewForm = true
                    }
                  }
                },
                [_vm._v("\n        レビューを投稿する\n      ")]
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }